// src/components/layout/Header.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import RealTimeSearch from '../search/RealTimeSearch';
import SettingsDropdown from '../settings/SettingsDropdown';
import { useAppContext } from '../../context/AppContext'; // Import context hook

const Header = () => {
  const { openSettingsModal, openMyAccountModal } = useAppContext(); // Get the functions from context
  
  const handleHelpClick = () => {
    // For now, show an alert. This could be replaced with a help modal or navigation to a help page
    alert('For assistance, contact Encore Support.');
  };
  
  return (
    // Increase z-index from z-10 to z-30
    <div className="absolute top-0 left-0 right-0 h-10 flex items-center justify-between px-4 shadow-md z-30" 
         style={{ backgroundColor: 'rgb(16, 54, 110)' }}>
      <Link to="/" className="flex items-center cursor-pointer hover:opacity-90">
        <img 
          src="/encore_logo_notext_min.png" 
          alt="Encore Logo"
          className="h-8"
        />        
        <div className="text-xs text-white opacity-80 ml-1">ENCORE INTERACTIVE</div>
      </Link>
      
      {/* Real-time search component */}
      <div className="flex-grow max-w-[60rem] mx-10">
        <RealTimeSearch />
      </div>
      
      <div className="flex items-center">
        <SettingsDropdown 
          onSettingsClick={openSettingsModal}
          onMyAccountClick={openMyAccountModal}
          onHelpClick={handleHelpClick}
        />
      </div>
    </div>
  );
};

export default Header;
